export const MOBILE_DIGIT_COUNT = 10;

export function sanitizeMobileInput(value) {
  return String(value ?? "").replace(/\D/g, "").slice(0, MOBILE_DIGIT_COUNT);
}

export function isValidMobileNumber(value) {
  const digits = String(value ?? "").trim();
  if (!digits) return true;
  return /^\d{10}$/.test(digits);
}

export function mobileValidationMessage(value, { required = false, label = "Mobile number" } = {}) {
  const digits = String(value ?? "").trim();
  if (!digits) {
    return required ? `${label} is required.` : null;
  }
  if (!/^\d{10}$/.test(digits)) {
    return `${label} must be exactly 10 digits.`;
  }
  return null;
}
